import { useMemo } from 'react'
import { PlanAreaFrameLines, PlanAreaFrameLinesProps } from '@scene'
import useSceneElement from './useSceneElement'

/**
 * Previews plan settings that aren't saved yet (a plan settings form's current values) in the
 * scene: draws their plan area frame as a scene element, while the frame of the saved settings
 * (`PlanAreaFrame`) steps aside; other visuals of the plan settings (e.g. the plan view's template
 * image) read the previewed values via `selectPreviewedPlanSettings`. Without settings (e.g. invalid form values) nothing is previewed
 * and the saved frame shows again. Neither the query cache nor any store is touched.
 */
const usePlanSettingsScenePreview = (planSettings: PdfPlanSettings | undefined): void => {
  // Form values come in as a new object on every change; only an actual change may re-register
  // the scene element.
  const planSettingsKey = planSettings ? JSON.stringify(planSettings) : null
  const properties = useMemo<PlanAreaFrameLinesProps>(
    () => ({ planSettings: planSettingsKey ? JSON.parse(planSettingsKey) : undefined }),
    [planSettingsKey],
  )

  useSceneElement({
    enabled: !!planSettingsKey,
    properties,
    component: PlanAreaFrameLines,
  })
}

export default usePlanSettingsScenePreview
